import EmisSupportAPI from '@/apis/business/teacher/emis-support-api.js'
import { HttpStatusCode } from '@/common/constant'

export default {
  namespaced: true,
  state: {
    trainingList: []
  },
  mutations: {
    setTrainingList (state, trainingList) {
      state.trainingList = trainingList
    }
  },
  getters: {},
  actions: {
    /**
       * Lấy link đăng nhập MisaId
       * @param {*} context
       * @param {*} params
       * @returns
       */
    async getTrainingList (context, params) {
      const res = await EmisSupportAPI.getAsync('training-schedule', { params })
      if (
        res &&
        res.IsSuccess &&
        res.Code === HttpStatusCode.OK &&
        res.Data
      ) {
        context.commit('setTrainingList', res.Data)
      }
    },

    /**
     * Đề xuất tập huấn
     * @param {*} content
     * @param {*} params
     * @returns
     */
    async postTrainingContent (content, params) {
      return await EmisSupportAPI.postAsync('training-content', params)
    }
  }
}
